export const MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  PURCHASE_SUSHI: 'purchase-modal-sushi',
  PURCHASE_SUSHI_REVIEW: 'purchase-modal-review-sushi',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  COLLEGE_AFFILIATION: 'college-affiliation',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic',
  MARKET_OWNERSHIP_CONFLICT: 'market-ownership-conflict',
  TWO_FACTOR: 'two-factor',
  TWO_FACTOR_PROMPT: 'two-factor-prompt',
  PHONE_UPDATE: 'phone-update',
  SMALL_PRICE_ODDS: 'small-price-odds',
  SMALL_PREDICTIT_INDEX: 'small-predictit-index',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_SHARE_INFO: 'small-share-info',
  SMALL_DEPOSIT_NUMBER_INFORMATION: 'small-deposit-number-information',
  SMALL_OFFER_INFO: 'small-offer-info',
  RECAPTCHA_CHALLENGE: 'recaptcha-challenge',
  SMALL_PAYOUT_INFO: 'payout-info',
  CUSTOMIZE_YOUR_PREDICTIT: 'customize-your-predictit',
};

export default MODALS;



// WEBPACK FOOTER //
// ./src/components/app/app-modals/modals-constants.js